import { useEffect, useRef, useState } from 'react'
import { Button, Divider, Drawer, Popover, Radio, Space } from 'antd'
import { ReactComponent as LayerIcon } from 'leaflet/src/images/layers.svg'
import * as L from 'leaflet'
import GoogleMapLayer from './bases/GoogleMapLayer'
import GoogleMapSatelliteLayer from './bases/GoogleMapSatelliteLayer'
import { useWindowDimensionContext } from '../../../hooks/WindowDimensionProvider'


const Content = ({ defaultLayer='gmap', children }) => {
  const [tileLayer, setTileLayer] = useState(defaultLayer)

  return (
    <div style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
      <Space
        size={0}
        direction='vertical'
        split={<Divider size='small'/>}
        style={{ width: '100%' }}
      >
        <Radio.Group
          style={{ display: 'flex', flexDirection: 'column' }}
          onChange={e => setTileLayer(e.target.value)}
          value={tileLayer}
          options={[
            { label: 'Google Map', value: 'gmap' },
            { label: 'Google Map Satellite', value: 'gmap_satellite' },
          ]}
        />
        {children}
      </Space>
      <>
        {tileLayer === 'gmap' && <GoogleMapLayer/>}
        {tileLayer === 'gmap_satellite' && <GoogleMapSatelliteLayer/>}
      </>
    </div>
  )
}


export default function LayerControl({ defaultLayer='gmap', popUpWidth=undefined, children }) {
  const [isOpen, setOpen] = useState(false)
  const ref = useRef(null)

  const { lessThanOrEqual } = useWindowDimensionContext()
  const isOnMobile = lessThanOrEqual('md')

  useEffect(() => { setOpen(false) }, [isOnMobile])
  useEffect(() => {
    if (ref.current) {
      L.DomEvent.disableClickPropagation(ref.current)
    }
  }, [])

  return (
    <>
      <div className='leaflet-top leaflet-right'>
        <div className='leaflet-control' ref={ref}>
          {isOnMobile ? (
            <>
              <Button
                size='large'
                icon={<LayerIcon/>}
                style={{ padding: '1.5rem' }}
                onClick={() => setOpen(true)}
              />
              <Drawer
                forceRender
                placement='bottom'
                open={isOpen}
                onClose={() => setOpen(false)}
              >
                <Content defaultLayer={defaultLayer}>{children}</Content>
              </Drawer>
            </>
          ) : (
            <Popover
              fresh
              forceRender
              arrow={false}
              trigger='hover'
              placement='bottomRight'
              open={isOpen}
              onOpenChange={open => setOpen(open)}
              content={<div style={{ width: popUpWidth }}><Content defaultLayer={defaultLayer}>{children}</Content></div>}
            >
              <Button
                size='large'
                icon={<LayerIcon/>}
                style={{ padding: '1.5rem' }}
              />
            </Popover>
          )}
        </div>
      </div>
    </>
  )
}